import { DASHBOARD } from "./action";

const INITIAL_STATE = {
  ContractLicenseList: { allowedCount: 0 },
  TicketLicenseList: { allowedCount: 0 },
  LoginLicenseList: { allowedCount: 0 },
  inventoryList: [],
  commodityData: [],
  fetchingComplete: false
};

export function dashboardReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case DASHBOARD.getdashboardinfoList.start:
      return Object.assign({}, state, {
        fetchingComplete: false
      });
    case DASHBOARD.getdashboardinfoList.success:
      return Object.assign({}, state, {
        fetchingComplete: true,
        dashboardList: action.data.data
      });
    case DASHBOARD.getContractLicenceinfoList.start:
      return Object.assign({}, state, {
        fetchingComplete: false
      });
    case DASHBOARD.getContractLicenceinfoList.success:
      return Object.assign({}, state, {
        fetchingComplete: true,
        ContractLicenseList: action.data.data
      });
    case DASHBOARD.getTicketLicenceinfoList.start:
      return Object.assign({}, state, {
        fetchingComplete: false
      });
    case DASHBOARD.getTicketLicenceinfoList.success:
      return Object.assign({}, state, {
        fetchingComplete: true,
        TicketLicenseList: action.data.data
      });
    case DASHBOARD.getLoginLicenceinfoList.start:
      return Object.assign({}, state, {
        fetchingComplete: false
      });
    case DASHBOARD.getLoginLicenceinfoList.success:
      return Object.assign({}, state, {
        fetchingComplete: true,
        LoginLicenseList: action.data.data
      });
    case DASHBOARD.getInventoryStatus.start:
      return {
        ...state,
        fetchingComplete: false
      };
    case DASHBOARD.getInventoryStatus.success:
      return {
        ...state,
        fetchingComplete: true,
        inventoryList: action.data.data
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducer.js